export enum FieldEditorType {
    Input,
    Textarea
}